import gsap from 'gsap';
import ScrollToPlugin from 'gsap/dist/ScrollToPlugin';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';

gsap.registerPlugin(ScrollToPlugin);
gsap.registerPlugin(ScrollTrigger);

const getWinScrollTop = () => {
    const w = window;
    const d = document;
    const g = d.getElementsByTagName('body')[0];

    return w.pageYOffset !== undefined ? w.pageYOffset : (d.documentElement || g.parentNode || g).scrollTop;
};

class NavScrollTriggerController {

    constructor(view) {
        this.view = view;
        this.state = {
            isOn: false,
            progress: 0
        };
    }

    start() {
        if (this.triggerTl) {
            return;
        }

        this.state.isOn = true;

        this.triggerTl = gsap.fromTo(this.state, { progress: 0 }, {
            progress: 1,
            duration: 3,
            ease: 'linear',
            scrollTrigger: {
                trigger: document.querySelector('.main'),
                start: 'top top',
                end: 'bottom bottom',
                // Needs a timeline to apply to
                scrub: 1
            },
            onUpdate: () => {
                if (!this.state.isOn) return;

                this.view.progress = this.state.progress;
            }
        });
    }

    pause() {
        if (this.state.isOn === false) return;

        this.state.isOn = false;

        if (this.triggerTl) {
            this.triggerTl.scrollTrigger.disable();
        }
        this._storeScrollY = getWinScrollTop();
    }

    resume(forceUpdate) {
        if (this.state.isOn === true) return;

        const _resume = () => {
            this._storeScrollY = undefined;

            this.triggerTl.scrollTrigger.enable();

            this.state.progress = this.view.progress;
            this.state.isOn = true;
        };

        if (forceUpdate) {
            _resume();

            return;
        }

        const prevY = this._storeScrollY;

        if (typeof prevY === 'number' && !Number.isNaN(prevY)) {
            gsap.killTweensOf(window);

            gsap.to(window, {
                scrollTo: this._storeScrollY,
                duration: 0,
                onComplete: _resume
            });
        }
    }

    get paused() {
        return !this.state.isOn;
    }
}

export default NavScrollTriggerController;
